export default "__VITE_ASSET__LYKTaZFj__"